import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';

import { MatSort } from '@angular/material/sort';
import { MatTable } from '@angular/material/table';
import { MatDialogRef } from '@angular/material/dialog';

import { IUser } from '@services/registrations/registrations.models';

import { DialogService } from '@services/dialog/';
import { RegistrationsService } from '@services/registrations';

import { ViewUserDetailsComponent } from './../view-user-details/view-user-details.component';

@Component({
	selector: 'app-search-user',
	templateUrl: './search-user.component.html',
	styleUrls: ['./search-user.component.scss']
})
export class SearchUserComponent implements OnInit {
	public users: IUser[];
	public sortOrder = 'asc';
	public sortColumn = 'firstname';

	@ViewChild(MatSort) sort: MatSort;
	@ViewChild(MatTable) table: MatTable<any>;
	public tableColumns: string[] = ['firstname', 'lastname', 'email'];

	formInputs = new FormGroup({
		userId: new FormControl('', [Validators.required])
	});

	get formIsValid(): boolean {
		return this.formInputs.valid;
	}

	constructor(
		private dialogRef: MatDialogRef<SearchUserComponent>,
		private dialogService: DialogService,
		public registrationsService: RegistrationsService
	) { }

	ngOnInit(): void {
	}

	close(event): void {
		this.dialogRef.close();
	}

	findUsers(): void {
		this.registrationsService.searchUsers(
			this.formInputs.controls.userId.value
		).subscribe((res: IUser[]) => {
			this.users = res;
		});
	}

	viewUserDetails(user: IUser): void {
		console.log('SearchUserComponent - veiwUserDetails: ', user);
		this.dialogService.open(ViewUserDetailsComponent, {
			data: {
				user: user,
				callback: (requestId: string) => {
				}
			}
		});
	}
}
